import { useOrganizationStore } from '~/store/organization';
import { useAccountStore } from '~/store/account';
import { useBusinessesStore } from '~/store/businesses';
import { resolveDefaultLandingUrl } from '~/composables/use-default-landing-url';
import { getFirstQueryParam } from '~/utils/common';

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name === 'auth-logout' || to.name === 'auth-login') {
    return;
  }

  const organizationStore = useOrganizationStore();
  const { organization } = storeToRefs(organizationStore);
  const accountStore = useAccountStore();
  const { currentAccount } = storeToRefs(accountStore);

  const queryRedirect = getFirstQueryParam(to.query.redirect);
  const redirectOverride =
    typeof queryRedirect === 'string' && queryRedirect.startsWith('/')
      ? queryRedirect
      : null;
  const fallbackLanding = () =>
    redirectOverride ?? resolveDefaultLandingUrl(organization.value);

  const isWelcomeScreenPending =
    Boolean(organization.value?.isWelcomeScreenEnabled) &&
    currentAccount.value?.welcomeScreenClosedAt === null;

  if (to.name !== 'welcome-screen' && isWelcomeScreenPending) {
    return navigateTo('/welcome-screen');
  } else if (
    to.name === 'welcome-screen' &&
    currentAccount.value?.welcomeScreenClosedAt
  ) {
    return navigateTo(fallbackLanding());
  }

  if (!currentAccount.value || !organization.value?.isBusinessesEnabled) {
    return;
  }

  const selectorEnabled = Boolean(
    organization.value?.organizationSettings?.businessSelectorEnabled,
  );

  const businessesStore = useBusinessesStore();
  const { selectedBusiness, businessesCount } = storeToRefs(businessesStore);

  await businessesStore.initialize({ forceSelectFirst: !selectorEnabled });

  if (!selectorEnabled) {
    if (to.name === 'business-selection') {
      return navigateTo(fallbackLanding());
    }
    return;
  }

  if (businessesCount.value < 2 && to.name === 'business-selection') {
    return navigateTo(fallbackLanding());
  }

  if (
    to.name !== 'business-selection' &&
    !isWelcomeScreenPending &&
    !selectedBusiness.value &&
    businessesCount.value > 1
  ) {
    return navigateTo('/business-selection');
  }
});
